"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicalInterestsContentText = exports.ClinicalInterestsTitle = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Renderer_1 = require("@kyruus/rich-text/Renderer");
exports.ClinicalInterestsTitle = styled_1.default.h2 `
  border: none;
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.ClinicalInterestsContentText = (0, styled_1.default)((props) => (react_1.default.createElement(Renderer_1.RichTextRenderer, Object.assign({}, props, { styleReset: "revert" /* reset any styling from the consuming context */ })))) `
  &.${Renderer_1.STYLE_RESET_CLASSNAME} {
    p&,
    p,
    h3,
    h4,
    h5,
    h6 {
      margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
      line-height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      white-space: normal;
    }

    ul,
    ol {
      line-height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
      list-style-position: outside;
      padding: 0;
      margin: 0 0 10px 25px;
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
      white-space: normal;
    }

    hr {
      margin: 20px 0;
      white-space: normal;
    }

    h6 {
      font-size: 0.75em;
    }
  }
`;
//# sourceMappingURL=styles.js.map